import { useCallback, useEffect, useSyncExternalStore } from 'react';

import { useUserSettings } from '@shared';
import { timezoneStore, getDefaultTimezone } from '@utilities/timezones';
import type { StoreSnapshot } from '@utilities/timezones';

const TIMEZONE_STORAGE_KEY = 'App-Meta-timezone';

type UseTimezoneResult = [string, (timezone: string) => void];

export const useTimezone = (): UseTimezoneResult => {
  const [timezone, setTimezoneToStorage] = useUserSettings<string>(
    getDefaultTimezone(),
    TIMEZONE_STORAGE_KEY
  );

  // const [getInitialTimezone, setTimezoneToStorage] = useStorage<string>({
  //   storageKey: TIMEZONE_STORAGE_KEY,
  // });

  const state = useSyncExternalStore<StoreSnapshot>(
    timezoneStore.subscribe,
    timezoneStore.getSnapshot
  );

  useEffect(() => {
    timezoneStore.updateState({ currentTimezone: timezone });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeTimezone = useCallback(
    (timezone: string) => {
      timezoneStore.updateState({ currentTimezone: timezone });

      setTimezoneToStorage(timezone);
    },
    [setTimezoneToStorage]
  );

  return [state.currentTimezone, changeTimezone];
};
